/**
 * @generated SignedSource<<62a34d3ed89a19542b6497ca6ff197b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type DeleteValveManufacturerInput = {
  valveManufacturerId: string;
  clientMutationId?: string | null;
};
export type ValveManufacturersTableDeleteValveManufacturerMutation$variables = {
  input: DeleteValveManufacturerInput;
};
export type ValveManufacturersTableDeleteValveManufacturerMutationVariables = ValveManufacturersTableDeleteValveManufacturerMutation$variables;
export type ValveManufacturersTableDeleteValveManufacturerMutation$data = {
  readonly deleteValveManufacturer: {
    readonly valveManufacturer: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly message: string;
    }>;
  } | null;
};
export type ValveManufacturersTableDeleteValveManufacturerMutationResponse = ValveManufacturersTableDeleteValveManufacturerMutation$data;
export type ValveManufacturersTableDeleteValveManufacturerMutation = {
  variables: ValveManufacturersTableDeleteValveManufacturerMutationVariables;
  response: ValveManufacturersTableDeleteValveManufacturerMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteValveManufacturerPayload",
    "kind": "LinkedField",
    "name": "deleteValveManufacturer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValveManufacturer",
        "kind": "LinkedField",
        "name": "valveManufacturer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ValveManufacturersTableDeleteValveManufacturerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValveManufacturersTableDeleteValveManufacturerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bce5591caede64f71c70dd0590616724",
    "id": null,
    "metadata": {},
    "name": "ValveManufacturersTableDeleteValveManufacturerMutation",
    "operationKind": "mutation",
    "text": "mutation ValveManufacturersTableDeleteValveManufacturerMutation(\n  $input: DeleteValveManufacturerInput!\n) {\n  deleteValveManufacturer(input: $input) {\n    valveManufacturer {\n      id\n      name\n    }\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a7151e0f1a45ecd879e3c45f8fd1963";

export default node;
